import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { enqueueSnackbar } from 'notistack';

import { useManageDeleteObjModalV2Store } from './useManageDeleteObjModalV2';

import useDeleteObject from 'hooks/Object/useDeleteObject';
import useGetClientsOnMap from 'hooks/Clients/useGetClientsOnMap';

const DeleteObjModalV2 = () => {
  const { t } = useTranslation();
  const { deleteObject } = useDeleteObject();
  const { refetch } = useGetClientsOnMap();
  const { isOpen, title, objectName, id, onManageObjectDeleteModalV2Close } = useManageDeleteObjModalV2Store();
  const onDelete = () => {
    deleteObject(id || 0, {
      onError: (error: any) => {
        if (error.response.data.detail) {
          enqueueSnackbar(error.response.data.detail, { variant: 'error' });
        }
      },
      onSuccess: () => {
        enqueueSnackbar(t('ClientTable.delete-modal-success-message-with-name', { objectName }), {
          variant: 'success',
        });
        onManageObjectDeleteModalV2Close();
        refetch();
      },
    });
  };
  return (
    <div>
      <Modal isOpen={isOpen} toggle={onManageObjectDeleteModalV2Close} size="md">
        <ModalHeader className="border-bottom pt-3 pb-2 mx-2" toggle={onManageObjectDeleteModalV2Close}>
          {title}
        </ModalHeader>
        <ModalBody>
          {t('Modals.delete-modal.msg')}
          <span className="text-danger fs-16">{` ${objectName} `}</span>?
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              onManageObjectDeleteModalV2Close();
            }}
            className="btn btn-ghost-danger"
          >
            {t('Modals.delete-modal.cancel')}
          </Button>{' '}
          <Button
            className="btn btn-ghost-success"
            onClick={() => {
              onDelete();
              onManageObjectDeleteModalV2Close();
              refetch();
            }}
          >
            {t('Modals.delete-modal.delete')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteObjModalV2;
